import { connect } from 'react-redux';

import { PlacesServiceStatus } from 'ha/types/GoogleMaps';
import reportError from 'ha/helpers/bugsnag/reportError';
import { getFeatureFlags } from 'ha/modules/FeatureFlags';

import Locations from './Locations';

// for more info please visit: https://developers.google.com/maps/documentation/javascript/reference/places-service#PlacesServiceStatus
const PLACES_STATUS_TO_REPORT = [
  PlacesServiceStatus.INVALID_REQUEST,
  PlacesServiceStatus.OVER_QUERY_LIMIT,
  PlacesServiceStatus.UNKNOWN_ERROR,
  PlacesServiceStatus.REQUEST_DENIED,
  PlacesServiceStatus.OVER_DAILY_LIMIT,
];

// specify a smallest area with all KYC countries included
// to give better suggestions if KYC is enabled
// resulting circle: https://www.mapdevelopers.com/draw-circle-tool.php?circles=%5B%5B16093.4%2C50.3175686%2C17.2487116%2C%22%23AAAAAA%22%2C%22%23000000%22%2C0.4%5D%2C%5B2623270.2%2C50.9251131%2C10.9461493%2C%22%23AAAAAA%22%2C%22%23000000%22%2C0%5D%5D
const kycLat = 50.925113;
const kycLng = 10.946149;
const kycRadius = 2623270;

// This is our workaround to manage in a better way the injection of the services from a thunk
// The main idea here is to abstract the container of the creation of the autocompleteService
// and only manage getPlacePredictions because in the future this can be changed/replaced with another service
// main issue about services in thunks: https://github.com/housinganywhere/ha/pull/5221
export const loadSuggestionsService =
  ({ value, predictionTypes }) =>
  (_, getState, { googleMapApi }) => {
    return googleMapApi.init().then(
      autocompleteService =>
        new Promise((resolve, reject) => {
          const featureFlags = getFeatureFlags(getState());
          const sdk = googleMapApi.getSdk();

          const kycProps =
            featureFlags.searchKYC === 'on'
              ? {
                  location: new sdk.LatLng(kycLat, kycLng),
                  radius: kycRadius,
                }
              : {};

          autocompleteService.getPlacePredictions(
            {
              input: value,
              types: predictionTypes,
              ...kycProps,
            },
            (results, status) => {
              if (status === PlacesServiceStatus.OK) {
                resolve(results);
              }

              if (status === PlacesServiceStatus.ZERO_RESULTS) {
                resolve([]);
              }

              if (PLACES_STATUS_TO_REPORT.includes(status)) {
                reportError(`location input error ${status}`);
                reject(new Error(status));
              }

              reject(new Error(status));
            },
          );
        }),
    );
  };

export default connect(null, (dispatch, { predictionTypes }) => ({
  loadSuggestions: value =>
    dispatch(loadSuggestionsService({ value, predictionTypes })),
}))(Locations);
